import { ListConditionsService } from 'application/services/list-conditions'
import { api } from 'infra/adapters/http-client-adapter'

export const handleListConditions = new ListConditionsService(api)
